// Phase 13 — Lightweight public-config + payments flag hook.
import { useEffect, useState } from "react";
import { api } from "./api";

let _cached = null;
let _inFlight = null;

export function usePublicConfig() {
  const [cfg, setCfg] = useState(_cached);

  useEffect(() => {
    if (_cached) {
      setCfg(_cached);
      return;
    }
    if (!_inFlight) {
      _inFlight = api
        .get("/public/config")
        .then((r) => {
          _cached = r.data;
          return r.data;
        })
        .catch((e) => {
          console.error("public/config load failed", e);
          _cached = { payments_enabled: false, phase: "20", live_events_enabled: true, certificates_enabled: false, leaderboards_enabled: false, freddy_intel_enabled: false, community_enabled: false };
          return _cached;
        })
        .finally(() => {
          _inFlight = null;
        });
    }
    _inFlight.then((d) => setCfg(d));
  }, []);

  return cfg || { payments_enabled: false, phase: "20", live_events_enabled: true, certificates_enabled: false, leaderboards_enabled: false, freddy_intel_enabled: false, community_enabled: false };
}

export function refreshPublicConfig() {
  _cached = null;
  _inFlight = null;
}
